const AppTheme = {
    light: {
        textColor: "#000",
        backgroundColor: "#fff",
    },
    dark: {
        textColor: "#fff",
        backgroundColor: "#333"
    }
}

export default AppTheme;
